import { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { getCostcodeByIds } from './state/costcodes.actions';
import Debouncer from '../helpers/Debouncer';
import { compareArrays } from '../helpers/helpers';

export default function useUpdateCostcodeIdMap({
  items,
  previousItems,
  setPreviousItems,
  columns,
  onLoad = () => {},
}) {
  const dispatch = useDispatch();
  const debouncerRef = useRef(new Debouncer());
  const costcodeIds = useMemo(() => (
    Array.from(
      new Set(items?.map((task) => task?.costcodeId) ?? []),
    ).filter(Boolean)
  ), [items]);
  const columnsKey = useMemo(
    () => [...(columns || [])]
      .sort((a, b) => String(a).localeCompare(String(b)))
      .join(','),
    [columns],
  );
  useEffect(() => {
    const loadCostcodes = async () => {
      if (!costcodeIds.length) return;
      const {
        added,
        removed,
      } = compareArrays(items, previousItems, 'costcodeId');
      if (!added.length && !removed.length) return;
      setPreviousItems?.(items);

      await dispatch(getCostcodeByIds(
        costcodeIds,
        columnsKey ? { columns: columnsKey.split(',') } : {},
      ));
      onLoad?.();
    };
    debouncerRef.current.debounce(loadCostcodes, 1000);
  }, [
    costcodeIds,
    columnsKey,
    onLoad,
    items,
    previousItems,
    setPreviousItems,
  ]);

  useEffect(() => () => debouncerRef.current.clear(), []);
}
